<template>
    <div class="blacklist-page p-1">
        <b-row class="">
            <b-col class="mb-3" md="3" v-for="card in statCards" :key="card.key">
                <div
                    class="alert-card shadow-sm p-2"
                    :class="card.cardClass"
                >
                    <div class="card-content">
                        <div class="icon-box" :class="card.iconClass">
                            <i :class="card.icon"></i>
                        </div>
                        <div class="card-text">
                            <div class="mb-1 main-title">{{ card.label }}</div>
                            <h5 class="m-0 font-weight-bold">
                                {{ stats[card.key] }}
                            </h5>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-card>
            <b-row>
                <b-col md="9">
                    <b-input
                        v-model="search"
                        class="height-40 mb-2"
                        placeholder="Search by name or email..."
                        @input="onSearchChange"
                    ></b-input>
                </b-col>

                <b-col md="3">
                    <b-form-select
                        v-model="filterType"
                        class="height-40 mb-2"
                        @change="onFilterChange"
                    >
                        <option value="">All Types</option>
                        <option value="Customer">Customer</option>
                        <option value="Seller">Seller</option>
                    </b-form-select>
                </b-col>
            </b-row>
        </b-card>

        <b-card>
            <b-table
                class="blacklist-table tableRadius"
                :dark="dark"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="loading"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :items="filteredList"
                :fields="fields"
                responsive
                show-empty
                thead-class="header"
            >
                <template #cell(type)="data">
                    <span
                        :class="[
                            'badge px-2',
                            data.value === 'Customer'
                                ? 'badge-blue'
                                : 'badge-purple',
                        ]"
                    >
                        {{ data.value }}
                    </span>
                </template>

                <template #cell(risk)="data">
                    <span
                        :class="[
                            'badge px-2',
                            data.value === 'High'
                                ? 'badge-red'
                                : data.value === 'Medium'
                                  ? 'badge-orange'
                                  : 'badge-green',
                        ]"
                    >
                        {{ data.value }}
                    </span>
                </template>
                <template #cell(blocked)="data">
                    <span
                    >
                        {{(data.item.updatedAt)}}
                    </span>
                </template>
                <!-- <template slot="cell(actions)" slot-scope="data">
                    <div class="inline_btnTable">
                        <b-button
                            size="sm"
                            class="button-circle mr-2"
                            variant="primary"
                        >
                            <i class="fa fa-eye"></i>
                        </b-button>

                        <b-button
                            size="sm"
                            class="button-circle mr-2 edit-button"
                        >
                            <i class="fa fa-pencil edit"></i>
                        </b-button>

                        <b-button
                            size="sm"
                            class="button-circle"
                            variant="danger"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </div>
                </template> -->
            </b-table>
            <div class="pagination-wrapper mb-1">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="filteredList.length"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            search: "",
            filterType: "",
            perPage: 10,
            currentPage: 1,
            loading: false,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            context: "Add",
            sortBy: "createdAt",
            sortDesc: true,
            stats: {
                total: 128,
                customers: 0,
                sellers: 0,
                month: 12,
            },

            fields: [
                { key: "name", label: "Name" },
                { key: "email", label: "Email" },
                { key: "type", label: "Type" },
                { key: "reason", label: "Reason" },
                { key: "risk", label: "Risk Level" },
                { key: "added", label: "Added Date" },
                { key: "blocked", label: "Blocked Date" },
                { key: "by", label: "Added By" },
                // { key: "actions", label: "Actions" },
            ],
        };
    },

    computed: {
        ...mapState({
            blockUserListData: (state) => state.fraudManagement.blockUserList,
        }),
        blockUserList() {
            if (!this.blockUserListData?.response) {
                return [];
            }
            return Array.isArray(this.blockUserListData.response)
                ? this.blockUserListData.response
                : [];
        },
        list() {
            if (!this.blockUserList || !Array.isArray(this.blockUserList)) {
                return [];
            }
            return this.blockUserList.map((item) => {
                const getName = () => {
                    if (item.name) {
                        const first = item.name.first || "";
                        const last = item.name.last || "";
                        return `${first} ${last}`.trim() || "Unknown";
                    }
                    return item.authentication?.userName || "Unknown";
                };

                const getType = () => {
                    if (item.category === "TENANT" || item.category == "OFFICE") {
                        return "Seller";
                    }
                    return "Customer";
                };

                const getRisk = () => {
                    if (item.status === "INACTIVE") {
                        return "High";
                    }
                    return "Medium";
                };

                const formatDate = (dateString) => {
                    if (!dateString) return "N/A";
                    const date = new Date(dateString);
                    return date.toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                    });
                };

                return {
                    name: getName(),
                    email: item.authentication?.email || "N/A",
                    type: getType(),
                    reason: "Blacklisted",
                    risk: getRisk(),
                    added: formatDate(item.createdAt),
                    by: "System",
                    updatedAt: formatDate(item.updatedAt)
                };
            });
        },
        statCards() {
            return [
                {
                    key: "total",
                    label: "Total Blacklisted",
                    icon: "fa fa-ban",
                    cardClass: "total-card",
                    iconClass: "total-icon",
                },
                {
                    key: "customers",
                    label: "Customers",
                    icon: "fa fa-user",
                    cardClass: "critical-card",
                    iconClass: "critical-icon",
                },
                {
                    key: "sellers",
                    label: "Sellers",
                    icon: "fa fa-store",
                    cardClass: "active-card",
                    iconClass: "active-icon",
                },
                {
                    key: "month",
                    label: "This Month",
                    icon: "fa fa-calendar",
                    cardClass: "investigation-card",
                    iconClass: "investigation-icon",
                },
            ];
        },

        filteredList() {
            return this.list.filter((item) => {
                const matchesSearch =
                    item.name
                        .toLowerCase()
                        .includes(this.search.toLowerCase()) ||
                    item.email
                        .toLowerCase()
                        .includes(this.search.toLowerCase());

                const matchesType =
                    this.filterType === "" || item.type === this.filterType;

                return matchesSearch && matchesType;
            }).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        },
    },
    watch: {
        search() {
            this.currentPage = 1;
        },
        filterType() {
            this.currentPage = 1;
        },
    },
    methods: {
        async fetchBlockUserList() {
           const res= await this.$store.dispatch("fraudManagement/fetchBlockUserList");
           this.stats.total = res?.meta?.total || 0;
        },
        onSearchChange() {
            this.currentPage = 1;
        },
        onFilterChange() {
            this.currentPage = 1;
        },
        async dashbboardStats() {
            const data = await this.$store.dispatch(
                "fraudManagement/fetchDashboardStats",
            );
            this.stats.customers = data?.totals?.customers || 0;
            this.stats.sellers = data?.totals?.partners || 0;
        },
    },
    mounted() {
        this.fetchBlockUserList();
        this.dashbboardStats();
    },
};
</script>

<style scoped>
.height-40{
    height: 40px;
}
.alert-card {
    height: 80px;
    border-radius: 10px;
    background: #fff;
    display: flex;
    align-items: center;
}

.card-content {
    display: flex;
    align-items: flex-start;
}

.card-text {
    margin-left: 0.75rem;
}
.main-title {
    font-size: clamp(13px, 2.6vw, 15px);
    font-weight: 500;
    color: #222;
}

.icon-box {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}
.total-icon {
    background: #d9eaff;
    color: #4a8ef0;
}
.critical-icon {
    background: #ffdad9;
    color: #e63939;
}
.active-icon {
    background: #ffe7c3;
    color: #ff9e1f;
}
.investigation-icon {
    background: #fff3b6;
    color: #d4a733;
}

.stats-blue {
    border-left: 4px solid #3b82f6;
}
.stats-red {
    border-left: 4px solid #ef4444;
}
.stats-orange {
    border-left: 4px solid #f59e0b;
}
.stats-yellow {
    border-left: 4px solid #eab308;
}

/* Badges */
.badge-blue {
    background: #e6f0ff;
    color: #1d4ed8;
}
.badge-purple {
    background: #f3e8ff;
    color: #6b21a8;
}
.badge-red {
    background: #ffe7e7;
    color: #dc2626;
}
.badge-orange {
    background: #fff4e5;
    color: #d97706;
}
.badge-green {
    background: #e9fce8;
    color: #15803d;
}

/* Action icons */
.action-icon {
    cursor: pointer;
    font-size: 14px;
}
.action-icon:hover {
    opacity: 0.7;
}
/* Blue Box */
.icon-blue {
    background: #e3edff;
    color: #3f7df1;
}
.border-blue {
    border-color: #dbe7ff !important;
}

/* Red Box */
.icon-red {
    background: #ffe5e5;
    color: #e63939;
}
.border-red {
    border-color: #ffd4d4 !important;
}

/* Orange Box */
.icon-orange {
    background: #ffeccd;
    color: #ff9800;
}
.border-orange {
    border-color: #ffe0b9 !important;
}

/* Yellow Box */
.icon-yellow {
    background: #e8f1ff;
    color: #4d7cf3;
}
.border-yellow {
    border-color: #d8e7ff !important;
}

/* Text Styling */
.card-title {
    margin: 0;
    font-size: 15px;
    color: #4d4d4d;
}
.card-value {
    margin-top: 10px;
    font-weight: bold;
    color: #000;
}

.blacklist-table {
    border-radius: 12px;
}

.edit-button {
    background: #fe7b08;
    border: #fe7b08;
}

.edit-button:hover {
    background: #e66a07;
    border-color: #e66a07;
}

.pagination-wrapper {
    float: right;
}

@media (max-width: 767.98px) {
    .alert-card {
        margin-top: 1rem;
        padding: 1rem !important;
    }

    .pagination-wrapper {
        float: none;
        text-align: center;
        width: 100%;
    }

    .blacklist-table {
        font-size: 12px;
    }
}
.inline_btnTable {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
}
</style>
